import { WhatsappMessage } from '../types/whatsapp';

export const shouldShowAgentBadge = (
    prevMessage: WhatsappMessage | undefined | null,
    currentMessage: WhatsappMessage
): boolean => {

    if (currentMessage.direction !== 'outbound') return false;


    if (!prevMessage) return true;


    if (prevMessage.direction !== 'outbound') return true;

    const prevAgentId = prevMessage.agentId || 'bot';
    const currAgentId = currentMessage.agentId || 'bot';

    return prevAgentId !== currAgentId;
};
